import { Col, Grid, Row } from 'antd';
import React from 'react';
import InscriptionTaxiDriver from './Components/InscriptionTaxiDriver';
import Footer from '../Welcome/components/Sections/Footer';
import TopNavbar from '../Welcome/components/Nav/TopNavbar';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const { useBreakpoint } = Grid;

const TaxiDriverInscriptionView = () => {
    const screens = useBreakpoint();
    const margin = screens.xs ? '10%' : '3%';
    const { t, i18n } = useTranslation();

    const inscriptionStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: margin,
        marginBlock: margin,
        flex: 1,
    };

    const containerStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
    };
    const titleStyle: React.CSSProperties = {
        textAlign: 'center',
        marginTop: '40px',
    };

    return (
        <div style={containerStyle}>
            <Helmet>
                <html lang={i18n.language} />
                <title>{t('driver.seo.title')}</title>
                <meta name="description" content={t('driver.seo.description')} />
                {/* Meta Pixel Code */}
                <script
                    dangerouslySetInnerHTML={{
                        __html: `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod ?
        n.callMethod.apply(n, arguments) : n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');

        fbq('init', '861885046902960');
        fbq('track', 'PageView');
      `,
                    }}
                />
                <noscript>
                    {`
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=861885046902960&ev=PageView&noscript=1"/>
    `}
                </noscript>
            </Helmet>

            <TopNavbar />
            <div style={titleStyle}>
                <h2> {t('title')}</h2>
            </div>
            <div style={inscriptionStyle}>
                <InscriptionTaxiDriver />
            </div>
            <Footer />
        </div>
    );
};

export default TaxiDriverInscriptionView;
